<template>
  <div class="profile-page">
    <div class="container">
      <ProfileInfo />
      <ProfileTeamToolbar :loaded="loaded" />
      <TeamView @loaded="loaded = true" />
    </div>
  </div>
</template>

<script>
import TeamView from "@/components/teams/TeamView";
import ProfileTeamToolbar from "./ProfileTeamToolbar";
import ProfileInfo from "./ProfileInfo";

export default {
  name: "ProfilePage",
  components: {
    TeamView,
    ProfileTeamToolbar,
    ProfileInfo
  },
  data: () => ({
    loaded: false
  }),
  breadcrumb: {
    title: "Профиль",
    to: "/profile"
  }
};
</script>
